<!-- Notification Toast -->
<div *ngIf="showNotificationMessage" 
     class="notification-toast" 
     [ngClass]="'notification-' + notificationType">
  <div class="notification-content">
    <span class="notification-icon">
      <i [ngClass]="notificationType === 'success' ? 'fas fa-check-circle' : 
                     (notificationType === 'error' ? 'fas fa-times-circle' : 'fas fa-exclamation-circle')"></i>
    </span>
    <span class="notification-message">{{ notificationMessage }}</span>
    <button class="notification-close" (click)="showNotificationMessage = false">
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>

<!-- Loading State -->
<div *ngIf="isLoading" class="divsubscription bg-white px-3 py-5">
  <div>
    <div class="text-center pt-5 pb-5">
      <div class="loader loader--style8" title="7">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
          <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
          </rect>
          <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
          </rect>
          <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
          </rect>
        </svg>
      </div>
    </div>  
  </div>   
</div>

<!-- Error State -->
<div *ngIf="loadingError && !isLoading" class="divsubscription bg-white px-3 py-5">
  <div class="container">
    <div class="alert alert-danger" role="alert">
      <h4 class="alert-heading">{{ 'common.error' | translate }}</h4>
      <p>Error loading order details</p>
      <hr>
      <button (click)="loadCompanyAddresses()" class="btn btn-primary">
        {{ 'common.retry' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Cart Review Content -->
<div *ngIf="!isLoading && !loadingError" class="">
  <div class="container pb-5">

    <!-- Breadcrumb -->
    <div class="mb-3">
      <app-breadcrumb 
        returnAction="/dashboard" 
        [breadcrumbs]="[
            { label: 'Company Management', url: '/setting/company-management' },
            { label: 'Pesanan' }
        ]"
      >
      </app-breadcrumb>
    </div> 

    <!-- Header -->
    <div class="card border-0 mb-3">
      <div class="row">
        <div class="col-sm-12">
          <div class="cd-title">Pesanan</div>
        </div>
      </div>
    </div>

    <!-- Stepper Navigation -->
    <div class="card border-0 mb-3">
      <div class="cd-content px-3 py-2">
        <div class="divsubscription pb-3">
          <div class="row g-0 justify-content-center pb-3">
            <div class="col-12">
              <nav class="d-flex flex-wrap text-center nav mt-sm-3 mt-lg-1">
                <!-- Step 1 -->
                <li class="flex-fill nav-item nav-rfq px-0 pt-2  active-link">
                  <a class="nav-link mn-color border-bottom border1 border-2 " (click)="goBackToProducts()" style="cursor: pointer;">
                    <i class="fas fa-shopping-bag me-2"></i>Langkah 1 (Pilih Paket)
                  </a>
                </li>

                <!-- Step 2 (Current) -->
                <li class="flex-fill nav-item nav-rfq px-0 pt-2 active-link">
                  <a class="nav-link mn-color border-bottom border1 border-2">
                    <i class="fas fa-list me-2"></i>Langkah 2 (Pesanan)
                  </a>
                </li>

                <!-- Step 3 -->
                <li class="flex-fill nav-item nav-rfq px-0 pt-2">
                  <a class="nav-link mn-color">
                    <i class="fas fa-credit-card me-2"></i>Langkah 3 (Konfirmasi Pesanan)
                  </a>
                </li>
              </nav>
            </div>
          </div>
        </div>

        <!-- Main Content -->
        <div class="mainContent">
            <!-- Company Information -->
            <div class="mb-3">
                <h6 class="fw-bold cdc1">{{companyName}}</h6>
            </div>



            <div class="row">
                <div class="col-sm-12"> <!-- col-sm-8 -->
                    <!-- Address Selection -->
                    <div class="mb-4">
                        <label class="form-label fw-bold">Alamat <span class="text-danger">*</span></label>
                        <select class="form-select" [(ngModel)]="selectedAddressId" [disabled]="isProcessing" style="border-color: var(--primary-color); border-radius: 8px;">
                            <option value="">Pilih Tujuan Pengiriman</option>
                            <option *ngFor="let address of companyAddresses" [value]="address.id">
                                {{ address.label }} - {{ formatAddress(address) }}
                                <span *ngIf="address.isMainAddress">(Utama)</span>
                            </option>
                        </select>
                        <!-- if companyAddresses empty, give notification to add address first in company settings -->
                        <sup *ngIf="companyAddresses.length === 0" class="text-danger mt-2">
                            <i class="bi bi-exclamation-triangle-fill me-1"></i>
                            Belum ada alamat perusahaan. Silakan tambahkan alamat di pengaturan perusahaan terlebih <a class="fw-bold fw-underline text-danger" href="/setting/company-detail">di sini</a>. 
                        </sup>

                    </div>
                </div>
                <!-- <div class="col-sm-4 text-end">
                    <p class="mb-3">

                        <a href="#" class="text-decoration-none small" style="color: #006572;">
                            <i class="bi bi-question-circle me-1"></i>
                            Panduan Tagihan & Pembayaran
                        </a>

                    </p>

                </div> -->
            </div>

            <!-- Selected Products Table -->
            <div class="card border-0 mb-4">
                <div class="card-header" style="background-color: #74bec1; color: white; padding: 15px 20px; border-radius: 8px 8px 0 0;">
                    <h6 class="mb-0 fw-bold">Paket Dipilih</h6>
                </div>
                <div class="cd-rfq-list-quote">
                    <div class="mb-2">
                        <div class="table-responsive mb-0">
                            <table class="table vlistqrfq mb-0 align-middle border-radius-0" cellpadding="10">
                                <thead>
                                    <tr style="background-color: #e8e8e8; border-bottom: 1px solid #006572;">
                                        <th scope="col" style="width: 8%; color: #333;">No.</th>
                                        <th scope="col" style="color: #333;">Produk</th>
                                        <th scope="col" style="color: #333;">Deskripsi</th>
                                        <th scope="col" class="text-center" style="width: 10%; color: #333;">Jumlah</th>
                                        <th scope="col" class="text-center" style="width: 15%; color: #333;">Harga</th>
                                        <th scope="col" class="text-center" style="width: 10%; color: #333;">Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Empty Cart Message -->
                                    <tr *ngIf="cartItemCount === 0">
                                        <td colspan="6" class="text-center py-4">
                                            <p class="text-muted mb-0">Tidak ada produk dalam pesanan</p>
                                        </td>
                                    </tr>

                                    <!-- Cart Items -->
                                    <tr *ngFor="let item of getAllCartItems()">
                                        <td class="align-middle text-center">
                                            <strong style="color: #006572; font-size: 16px;">{{ item.index }}</strong>
                                        </td>
                                        <td class="align-middle">
                                            <strong style="color: #006572;">{{ getProductName(item, item.type) }}</strong>
                                        </td>
                                        <td class="align-middle">
                                            <div class="mb-0 ps-3" style="color: #006572;">
                                                <ul *ngIf="item.type === 'subscription' && item.subscriptionFeature">
                                                    <li *ngFor="let feature of item.subscriptionFeature; let last = last">
                                                        {{ feature.featureName }} <strong *ngIf="feature.featureAvailableQty">: {{ feature.featureAvailableQty }}</strong><span *ngIf="!feature.featureAvailableQty"></span>
                                                    </li>
                                                </ul>
                                                <ul *ngIf="item.type === 'addon'">
                                                    {{ item.qtyOffered || '' }} kuota {{ item.addOnName }}
                                                </ul>
                                                <ul *ngIf="item.type === 'voucher'">
                                                    {{ item.creditOffered || '' }} kredit {{ item.voucherName }}
                                                </ul>
                                            </div>
                                        </td>
                                        <td class="align-middle text-center">
                                            <div class="btn-group" [style]="'border: ' + (item.type !== 'subscription' ? '1px' : '0px') + ' solid #006572; border-radius: 5px;'"  role="group" aria-label="Quantity adjuster">
                                                <button type="button" 
                                                        class="btn" 
                                                        [disabled]="(item.quantity || 1) <= 1 || item.type === 'subscription' || isProcessing"
                                                        (click)="decrementQuantity(item)" *ngIf="item.type != 'subscription'">
                                                    −
                                                </button>
                                                <input type="text" 
                                                       class="form-control form-control-sm text-center border-0" 
                                                       [value]="item.quantity || 1" 
                                                       min="1" 
                                                       max="999"
                                                       [disabled]="item.type === 'subscription' || isProcessing"
                                                       (blur)="onQuantityBlur($event, item)"
                                                       style="width: 60px; border-color: #006572; color: #006572; font-weight: bold;border-width: 0px !important;" readonly>
                                                <button type="button" 
                                                        class="btn" 
                                                        [disabled]="(item.quantity || 1) >= 999 || item.type === 'subscription' || isProcessing"
                                                        (click)="incrementQuantity(item)" *ngIf="item.type != 'subscription'">
                                                    +
                                                </button>
                                            </div>
                                        </td>
                                        <td class="align-middle text-end">
                                          <ng-container *ngIf="item.type === 'subscription' && isSubsribeFhProduct && subscriptionInfoPrice[item.fhProductOfferingId]?.subscriptionBuyingOption?.toLowerCase() === 'upgrade'">
                                            <div id="prorateDiv" style="font-size:12px; color:#888; line-height:1.6;">
                                              <span>(({{ subscriptionInfoPrice[item.fhProductOfferingId].existingTotalSubscriptionInDays }} - {{ subscriptionInfoPrice[item.fhProductOfferingId].existingSubscriptionDaysUsed }}) / {{ subscriptionInfoPrice[item.fhProductOfferingId].existingTotalSubscriptionInDays }}) x ({{ subscriptionInfoPrice[item.fhProductOfferingId].newSubscriptionPrice | number:'1.0-0' }} - {{ subscriptionInfoPrice[item.fhProductOfferingId].existingSubscriptionPrice | number:'1.0-0' }})</span><br>
                                              <!-- <span class="text-success">= {{ subscriptionInfoPrice[item.fhProductOfferingId].priceReductionResult | number:'1.0-0' }}</span> -->
                                            </div>
                                          </ng-container>
                                          <ng-container *ngIf="item.type === 'subscription' && isSubsribeFhProduct && subscriptionInfoPrice[item.fhProductOfferingId]?.subscriptionBuyingOption?.toLowerCase() === 'downgrade'">
                                            <small style="font-size:11px; color:#e67e22; font-weight:600;">Downgrade</small><br>
                                          </ng-container>
                                            <strong style="color: #006572; font-size: 16px;">{{ formatCurrency(getProductPrice(item, item.type)) }}</strong>
                                        </td>
                                        <td class="align-middle text-center">
                                            <button class="btn" 
                                                    style="background-color: #dc3545; color: white; padding: 6px 12px; border-radius: 4px; border: none; cursor: pointer;"
                                                    (click)="removeFromCart(item.fhProductOfferingId, item.type)"
                                                    [disabled]="isProcessing"
                                                    title="Hapus produk">
                                                <i class="bi bi-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>



            <!-- Summary Section Below Table -->
            <div class="row mb-4">
                <div class="col-md-6">

                    <!-- Add More Products Button -->
                    <div class="mb-4">
                        <button class="btn" 
                                style="background-color: #7ab8c4; color: white; padding: 10px 30px; border-radius: 6px; border: none; font-weight: 600;"
                                (click)="goBackToProducts()"
                                [disabled]="isProcessing">
                            <i class="bi bi-plus-lg me-2"></i>Tambah Paket Baru
                        </button>
                    </div>

                </div>
                <div class="col-md-6">
                    <div style="font-size: 14px;">
                        <div class="row mb-3">
                            <div class="col-6">
                                <span class="cdc1">Subtotal</span>
                            </div>
                            <div class="col-6 text-end cdc1">
                                {{ formatCurrency(subtotal) }}
                            </div>
                        </div>

                        <div class="row mb-3" *ngIf="taxRate > 0">
                            <div class="col-6">
                                <span class="cdc1">Pajak (10%)</span>
                            </div>
                            <div class="col-6 text-end cdc1">
                                {{ formatCurrency(taxAmount) }}
                            </div>
                        </div>

                        <div class="row" style="border-top: 2px solid #ddd; padding-top: 15px;">
                            <div class="col-6">
                                <span style="font-weight: bold; font-size: 16px;" class="cdc1">Total</span>
                            </div>
                            <div class="col-6 text-end cdc1">
                                <strong>{{ formatCurrency(totalAmount) }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </div>


      </div>
    </div>



  </div>
</div>


<div class="fixed-bottom">
  <div class="bg-white pt-3 pb-3">
    <div class="container">
      <div class="row">
        <div class="col-sm-6">

          <a class="btn btn-link rounded-1 roundedmore ps-4 pe-4 c1 fw-bold" href="/subscription-products">
              Kembali
          </a>

        </div>

        <div class="col-sm-6">
          <div class="d-flex justify-content-end">

                        <button class="btn cdbtn2 px-3" 
                                (click)="proceedToCheckout()"
                                [disabled]="isProcessing || cartItemCount === 0"
                                *ngIf="!isProcessing">
                            Lanjut ke Pembayaran
                        </button>

                        <button class="btn cdbtn2 px-3" 
                                disabled
                                *ngIf="isProcessing">
                            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Memproses...
                        </button>            

            
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>